import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useHistory, NavLink } from 'react-router-dom';
import { useRegionalLink } from 'hooks/useRegionalLink';
import isEqual from 'lodash/isEqual';
import cn from 'classnames';

import InputSearch from 'components/common/forms/InputSearch/InputSearch';
import {
  EmptyState,
  FilterButton,
  Loading,
  PaginationGroup,
  TableTitle,
  LinkBack
} from 'components/common/Elements/Elements';

import TableWidget from './parts/TableWidget/TableWidget';
import FiltersBlock from './parts/FiltersBlock/FiltersBlock';

import { devicesReq } from './helpers/helpers';
import { getRequest, postRequest } from 'utils/requests';
import {
  replaceHistory,
  checkingForExistenceOfOptions,
  clearOrDefaultFilters
} from 'utils/common';
import { defaultFilters, defaultNavigation } from './helpers/configurates';

import classes from './SwgBp.module.scss';

const SwgBp = ({ customerId }) => {
  const { t } = useTranslation(['activity']);
  const generateRegionalPath = useRegionalLink();

  const [filter, setFilter] = useState({
    ...defaultFilters,
    ...defaultNavigation
  });

  const [visibleFilterSave, setVisibleFilterSave] = useState(false);
  const [visibleFilterEdit, setVisibleFilterEdit] = useState(false);
  const [changeFilter, setChangeFilter] = useState('Default');
  const [trigerResetDatePicker, setTrigerResetDatePicker] = useState(false);

  // //filters and pagination
  const [filterButton, setFilterButton] = useState(false);

  // //data from api
  const [data, setData] = useState([]);
  const [filters, setFilters] = useState({});

  // //other data
  const [loader, setLoader] = useState(true);
  const [loaderTable, setLoaderTable] = useState(false);
  const [dataConection, setDataConection] = useState(false);

  const [startFilter, setStartFilter] = useState(false);
  const [prevStateFilter, setPrevStateFilter] = useState();

  // const [triggerSaveTableSettings, setTriggerSaveTableSettings] =
  //   useState(false);
  const [triggerStartEffect, setTriggerStartEffect] = useState(false);
  const [enabledRequest, setEnabledRequest] = useState(true);

  const history = useHistory();

  const tableHeight = useRef();
  const unmount = useRef(false);

  const handleInput = e => {
    setFilter({ ...filter, search: e.target.value, currentPage: 1 });
    setStartFilter(!startFilter);
  };

  const onClearSearch = () => {
    setFilter({ ...filter, search: '' });
    setStartFilter(!startFilter);
  };

  const handleFilterButton = () => {
    setFilterButton(!filterButton);
  };

  const changeCurrentPage = e => {
    setFilter({ ...filter, currentPage: e });
    setStartFilter(!startFilter);
  };

  const getFilterOptionsFromBackend = listFilter => {
    getRequest('customer/platform/security/swg/bp/list/filters')
      .then(res => {
        if (!unmount.current) {
          const { body } = res;
          setFilters({ ...filters, ...body });
          const newCheckingList = checkingForExistenceOfOptions(
            listFilter,
            setFilter,
            body
          );
          newCheckingList && setPrevStateFilter(newCheckingList);
          newCheckingList &&
            replaceHistory(
              filter,
              setEnabledRequest,
              history,
              'validation',
              newCheckingList,
              changeFilter
            );
        }
      })
      .catch(err => {
        !unmount.current && console.log(err);
      });
  };

  useEffect(() => {
    return () => {
      unmount.current = true;
    };
  }, []);

  useEffect(() => {
    const query = new URLSearchParams(history.location.search);
    if (triggerStartEffect) {
      if (
        !isEqual(prevStateFilter, filter) &&
        JSON.parse(query.get('filter')) !== null
      ) {
        replaceHistory(
          filter,
          setEnabledRequest,
          history,
          false,
          false,
          changeFilter
        );
      }
    }
    setTriggerStartEffect(true);
    // eslint-disable-next-line
  }, [startFilter]);

  useEffect(() => {
    if (enabledRequest) {
      setLoaderTable(true);
      const query = new URLSearchParams(history.location.search);

      if (
        query.get('filter') === null &&
        isEqual(filter, {
          ...defaultFilters,
          ...defaultNavigation
        })
      ) {
        replaceHistory(
          filter,
          setEnabledRequest,
          history,
          'replace',
          false,
          'Default'
        );
        setVisibleFilterEdit(false);
        setVisibleFilterSave(false);
        setPrevStateFilter(filter);

        requestForFilteredData();
      } else if (
        query.get('filter') === null &&
        !isEqual(filter, {
          ...defaultFilters,
          ...defaultNavigation
        })
      ) {
        resetAllfilters(true);
        replaceHistory(
          filter,
          setEnabledRequest,
          history,
          'replace',
          {
            ...defaultFilters,
            ...defaultNavigation
          },
          'Default'
        );
        setVisibleFilterEdit(false);
        setVisibleFilterSave(false);
      } else {
        setFilter(JSON.parse(query.get('filter')));
        setPrevStateFilter(JSON.parse(query.get('filter')));

        requestForFilteredData(JSON.parse(query.get('filter')));
        setChangeFilter(query.get('changeFilter'));
      }
      setTrigerResetDatePicker(!trigerResetDatePicker);
    }
    setEnabledRequest(true);

    // eslint-disable-next-line
  }, [history.location.search]);

  const requestForFilteredData = (listFilter = filter) => {
    const linkForRequest = `/customer/platform/security/swg/bp/list?page=${listFilter.currentPage}&limit=${listFilter.itemsPerPage}`;

    const REQ_BODY = devicesReq(listFilter, customerId);

    postRequest(linkForRequest, REQ_BODY)
      .then(res => {
        if (!unmount.current) {
          setData(res.body);
          setDataConection(true);
          setLoader(false);
          setLoaderTable(false);
          getFilterOptionsFromBackend(listFilter);
        }
      })
      .catch(err => {
        if (!unmount.current) {
          setDataConection(false);
          setLoader(false);
          setLoaderTable(false);
          console.log(err);
        }
      });
  };

  const resetAllfilters = (
    reload,
    onlyFilterLabel,
    onClickDefault,
    modeClearAll
  ) => {
    const newValueFilters = clearOrDefaultFilters(modeClearAll, defaultFilters);

    setFilter({ ...newValueFilters, ...defaultNavigation });

    if ((changeFilter === 'Default' || onClickDefault) && !modeClearAll) {
      setVisibleFilterSave(false);
      setVisibleFilterEdit(false);
    } else {
      setVisibleFilterSave('button');
      if (changeFilter !== 'Default') {
        setVisibleFilterEdit(true);
      }
    }
    if (!onlyFilterLabel) {
      setChangeFilter('Default');
    }

    setTrigerResetDatePicker(!trigerResetDatePicker);
    if (!reload) {
      setStartFilter(!startFilter);
    }
  };

  if (loader) {
    return <Loading />;
  }

  if (!dataConection) {
    return <EmptyState message="connect" />;
  }

  return (
    <>
      <div className={classes.titleAndLink}>
        <TableTitle
          className={classes.titleCounter}
          title={'Bypass Rules'}
          additional={data.totalRecords}
          withWordResult={false}
        />
        <div className={classes.subLinkWrap}>
          <NavLink
            className={cn(classes.sublinks_item, classes.sublinks_item_left)}
            activeClassName={classes.sublinks_item__active}
            to={generateRegionalPath('swg')}
          >
            Web Filter Rules
          </NavLink>
          <NavLink
            className={cn(classes.sublinks_item, classes.sublinks_item_right)}
            activeClassName={classes.sublinks_item__active}
            to={generateRegionalPath('swgBp')}
          >
            Bypass Rules
          </NavLink>
          <LinkBack text="Platform" />
        </div>
      </div>
      <div className={classes.filters_main}>
        <InputSearch
          placeholder={t('activity:filters.SEARCH')}
          value={filter.search}
          onChange={handleInput}
          onClearSearch={onClearSearch}
          className={classes.filter}
          disabled={loaderTable}
        />
        <FilterButton active={filterButton} onClick={handleFilterButton} />
      </div>
      <FiltersBlock
        filter={filter}
        setFilter={setFilter}
        startFilter={startFilter}
        setStartFilter={setStartFilter}
        filterButton={filterButton}
        filters={filters}
        trigerResetDatePicker={trigerResetDatePicker}
        resetAllfilters={resetAllfilters}
        setVisibleFilterSave={setVisibleFilterSave}
        setVisibleFilterEdit={setVisibleFilterEdit}
        visibleFilterSave={visibleFilterSave}
        visibleFilterEdit={visibleFilterEdit}
        changeFilter={changeFilter}
      />

      <div>
        <div ref={tableHeight}>
          <TableWidget data={data.data} />
        </div>

        {data.tableData && loaderTable === false && data.totalPages > 1 && (
          <PaginationGroup
            pageCount={data.totalPages}
            setPage={changeCurrentPage}
            currentPage={filter.currentPage}
            itemsTotal={data.teamMembersCount}
            itemsPerPage={filter.itemsPerPage}
          />
        )}
      </div>
    </>
  );
};

SwgBp.propTypes = {
  customerId: PropTypes.string
};

export default SwgBp;
